// TOEFL iBT Mock 1 — Writing (2026 format)
//
// 1. Build a Sentence – put the word tiles in order to complete a reply.
//                       One tile in some items is a distractor.
// 2. Write an Email   – 7 minutes, cover all three bullet points.
// 3. Academic Discussion – 10 minutes, respond to a professor's question.

export const TASK_SECONDS = {
  build: 6 * 60,
  email: 7 * 60,
  discussion: 10 * 60,
};

export const buildSentenceItems = [
  {
    id: 1,
    speaker: "Do you know when the seminar starts?",
    prefix: "I'm not sure, but",
    answer: ["let", "me", "check", "what", "time", "it", "begins"],
    suffix: ".",
    distractor: "does",
  },
  {
    id: 2,
    speaker: "Why weren't you at the meeting this morning?",
    prefix: "",
    answer: ["I", "had", "to", "take", "my", "car", "to", "the", "mechanic"],
    suffix: ".",
    distractor: "taking",
  },
  {
    id: 3,
    speaker: "Which book did you choose for your report?",
    prefix: "The one",
    answer: ["that", "our", "professor", "recommended", "last", "week"],
    suffix: ".",
    distractor: "who",
  },
  {
    id: 4,
    speaker: "Have you finished the reading for tomorrow?",
    prefix: "Not yet.",
    answer: ["I", "have", "been", "busy", "with", "my", "lab", "report"],
    suffix: ".",
    distractor: "has",
  },
  {
    id: 5,
    speaker: "Could you tell me where the registrar's office is?",
    prefix: "Sure,",
    answer: ["it", "is", "right", "next", "to", "the", "student", "center"],
    suffix: ".",
    distractor: "on",
  },
  {
    id: 6,
    speaker: "What did you think of the guest speaker?",
    prefix: "",
    answer: ["I", "wish", "she", "had", "talked", "more", "about", "her", "research"],
    suffix: ".",
    distractor: "have",
  },
  {
    id: 7,
    speaker: "Is the campus shuttle still running tonight?",
    prefix: "I'm not sure",
    answer: ["whether", "it", "runs", "after", "ten", "o'clock"],
    suffix: ".",
    distractor: "does",
  },
  {
    id: 8,
    speaker: "How did your presentation go?",
    prefix: "",
    answer: ["It", "went", "better", "than", "I", "had", "expected"],
    suffix: ".",
    distractor: "more",
  },
  {
    id: 9,
    speaker: "Are you coming to the study group on Thursday?",
    prefix: "",
    answer: ["I", "would", "come", "if", "I", "didn't", "have", "to", "work"],
    suffix: ".",
    distractor: "will",
  },
  {
    id: 10,
    speaker: "Why is the library so crowded today?",
    prefix: "",
    answer: ["Most", "students", "are", "studying", "for", "their", "final", "exams"],
    suffix: ".",
    distractor: "studies",
  },
];

export const emailTask = {
  recipient: "Ms. Patel",
  scenario:
    "You recently joined a volunteer group that cleans up local parks. Last Saturday, the clean-up event you signed up for was canceled, but you did not receive any notice and traveled a long way to get there. Write an email to the organizer, Ms. Patel.",
  points: [
    "Explain what happened last Saturday.",
    "Describe how the situation affected you.",
    "Suggest a way to keep volunteers informed in the future.",
  ],
  // Words that show each bullet point was addressed (used by the scorer).
  pointKeywords: [
    ["saturday", "cancel", "canceled", "cancelled", "arrived", "went", "traveled", "travelled", "nobody", "no one", "park", "event", "notice", "showed up", "got there"],
    ["wasted", "waste", "money", "frustrated", "frustrating", "disappointed", "upset", "bus", "hours", "inconvenient", "missed", "annoyed", "tired", "long way", "far", "ticket", "train", "affected"],
    ["suggest", "suggestion", "recommend", "could", "should", "perhaps", "maybe", "text message", "group chat", "notify", "notification", "send", "website", "mailing list", "in the future", "next time", "message", "app"],
  ],
};

export const discussionTask = {
  professor: "Dr. Gomez",
  question:
    "This week we have been discussing how technology is changing education. Some universities now record every lecture and post it online. Supporters say this helps students review material, but critics argue that it encourages students to skip class. Do you think universities should record and post all lectures online? Why or why not?",
  posts: [
    {
      name: "Kelly",
      text: "I think all lectures should be recorded. Many students work part-time or have family responsibilities, and they sometimes can't attend. Recordings make sure they don't fall behind, and everyone can rewatch difficult parts before exams.",
    },
    {
      name: "Andrew",
      text: "I disagree. If lectures are online, attendance will drop and class discussions will suffer. Part of learning is asking questions in real time and hearing classmates' ideas, which a recording can't replace.",
    },
  ],
  topicKeywords: [
    "lecture", "lectures", "record", "recorded", "recording", "recordings", "online", "class", "classes",
    "attend", "attendance", "student", "students", "university", "universities", "video", "videos",
    "review", "exam", "exams", "learn", "learning", "professor", "skip", "discussion", "rewatch",
  ],
};
